import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';


export default {
  email,
  mobile,
  api,
  cpp,
  figma,
  flutter,
  javascript,
  node,
  python,
  react,
  about01,
  about02,
  about03,
  profile,
  circle,
  logo,
};
